import { ElementType, HTMLAttributes, ReactNode } from "react";
import "./../../globals.scss";
import styles from "./Card.module.scss";

export interface CardProps extends HTMLAttributes<HTMLElement> {
  /** Render as a different element, e.g. "section" or "article". */
  as?: ElementType;
  /** Dark surface for emphasis cards (help centre, promos). */
  dark?: boolean;
  /**
   * Hover lift. Use when the card is wrapped in a link or button: the wrapper
   * owns the focus ring (see Card.module.scss), the card only shows hover.
   */
  interactive?: boolean;
  padding?: "none" | "sm" | "md";
  children: ReactNode;
}

export function Card({
  as: Tag = "div",
  dark,
  interactive,
  padding = "md",
  className,
  children,
  ...props
}: CardProps) {
  return (
    <Tag
      className={[
        styles.card,
        dark ? styles.dark : "",
        interactive ? styles.interactive : "",
        styles[`pad-${padding}`],
        className ?? "",
      ]
        .filter(Boolean)
        .join(" ")}
      {...props}
    >
      {children}
    </Tag>
  );
}
